import styles from './trailingDropZone.module.scss'

// the shared useDragSort overshoot buffer (invisible drop-hitbox below the last item, mid-drag
// only); spread on the drop-catching element itself — the `<td>` of a table zone row, or the
// `ListGroup.Item` of a list zone — so every sortable surface keeps identical geometry. Same
// shared-className-from-a-module pattern as `dragSortItemClassName`.
export const dragSortTrailingDropZoneClassName = styles.trailingDropZone
